export const DateHandlerSymbols = {
    DateHandlerService: Symbol.for("DateHandlerService")
}